// pages/auth/signin.tsx
import { useEffect } from 'react';
import { signIn, useSession } from 'next-auth/react';
import { useRouter } from 'next/router';
import { EuiLoadingSpinner, EuiSpacer, EuiText } from '@elastic/eui';

const PROVIDER_ID = 'da';

export default function SignIn() {
  const { status } = useSession();
  const router = useRouter();
  const cb =
    (typeof router.query.callbackUrl === 'string' &&
      router.query.callbackUrl) ||
    '/';

  useEffect(() => {
    if (status === 'unauthenticated') {
      // MUST produce /api/auth/signin/da?callbackUrl=...
      signIn(PROVIDER_ID, { callbackUrl: cb });
    } else if (status === 'authenticated') {
      router.replace(cb);
    }
  }, [status, cb, router]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: '4rem',
      }}>
      <EuiLoadingSpinner size="xl" />
      <EuiSpacer size="m" />
      <EuiText color="subdued">Redirecting to sign in…</EuiText>
    </div>
  );
}
